<template>
  <div class="animated fadeIn">
    <Tables
      ref="tableGrid"
      :columns="['RESPONSAVEL PELA CARTEIRA', 'PERIODICIDADE', 'DATA CADASTRO', 'STATUS', 'AÇÕES']"
      :showNew="true"
      :showReload="true"
      :showTipFooter="true"
      :messageTipFooter="'Clique no gerente para visualizar os produtos'"
      v-on:New="onNew"
      v-on:Load="onLoad"
      v-on:Reload="onLoad"
    >
      <tr v-for="obj in this.objList" v-bind:key="obj.id">
        <TableColumn
          :IsText="true"
          v-on:Edit="onEdit(obj)"
          :status="formatBooleanToInt(!obj.inative)"
          :value="
            obj.gerenteCarteira && obj.gerenteCarteira.pessoa
              ? obj.gerenteCarteira.pessoa.nome
              : 'N/D'
          "
        />
        <TableColumn
          :IsText="true"
          v-on:Edit="onEdit(obj)"
          :status="formatBooleanToInt(!obj.inative)"
          :value="
            obj.periodicidade !== undefined
              ? obj.periodicidade
              : 'N/D'
          "
        />
        <TableColumn
          :IsText="true"
          v-on:Edit="onEdit(obj)"
          :status="formatBooleanToInt(!obj.inative)"
          :value="
            obj.gerenteCarteira ? formatDateAndTime(obj.createdAt) : 'N/D'
          "
        />
        <TableColumn
          :IsText="true"
          v-on:Edit="onEdit(obj)"
          :status="formatBooleanToInt(!obj.inative)"
          :value="obj.inative ? 'Inativa' : 'Ativa'"
          :class="obj.inative ? 'text-danger' : 'text-success'"
        />
        <td class="row d-flex justify-content-center">
          <template>
            <div v-if="obj.inative">
              <b-dropdown variant="link" size="sm" no-caret>
                <template slot="button-content">
                  <i
                    class="fa fa-check cursor-pointer"
                    style="color: black;"
                    :title="$lang.Goals.AtiveGoalToolTip"
                  ></i>
                </template>
                <b-dropdown-header
                  ><strong>{{
                    $lang.Goals.ConfirmActiveGoal
                  }}</strong></b-dropdown-header
                >
                <b-dropdown-item
                  href="javascript:void(0);"
                  v-on:click="changeGoalStatus(obj, 'false')"
                  >{{ $lang.Common.Yes }}</b-dropdown-item
                >
                <b-dropdown-item href="javascript:void(0);">{{
                  $lang.Common.No
                }}</b-dropdown-item>
              </b-dropdown>
            </div>
            <div v-else>
              <b-dropdown variant="link" size="sm" no-caret>
                <template slot="button-content">
                  <i
                    class="fas fa-ban text-third cursor-pointer"
                    style="color: red;"
                    :title="$lang.Goals.InativeGoalToolTip"
                  ></i>
                </template>
                <b-dropdown-header
                  ><strong>{{
                    $lang.Goals.ConfirmInativeGoal
                  }}</strong></b-dropdown-header
                >
                <b-dropdown-item
                  href="javascript:void(0);"
                  v-on:click="changeGoalStatus(obj, 'true')"
                  >{{ $lang.Common.Yes }}</b-dropdown-item
                >
                <b-dropdown-item href="javascript:void(0);">{{
                  $lang.Common.No
                }}</b-dropdown-item>
              </b-dropdown>
            </div>
          </template>
        </td>
      </tr>
    </Tables>

    <div class="row">
      <div class="col-12 pb-3 pl-4">
        <button
          type="button"
          class="btn btn-third btn-sm"
          v-on:click="$emit('New')"
          v-b-tooltip.hover
          :title="'Clique para cadastrar'"
        >
          <i class="fas fa-plus"></i>
          <span class="d-md-down-none">&nbsp; Nova Meta</span>
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import ActionsForm from '@/shared/mixins/actionsForm'
import { loading } from '@/shared/utils/UIHelper'

import MetasRepository from '@/shared/http/repositories/metas/metas.js'
import { advancedOnException } from '@/components/tools/Utils'
import SidebarSearch from '@/views/private/configurations/account/components/search/SidebarUsuarios.vue'

export default {
  name: 'MetasList',
  mixins: [ActionsForm],
  data () {
    return {
      filters: null,
      data: null,
      form: null
    }
  },
  components: { SidebarSearch },
  methods: {
    onNew () {
      this.$emit('New')
    },
    onLoad () {
      this.onLoadAll()
    },
    changeGoalStatus (obj, status) {
      loading.push()
      let data = {
        inative: status
      }
      MetasRepository.ChangeStatus(obj.id, data)
        .then(() => {
          this.onLoadAll()
          loading.pop()
        })
        .catch(e => advancedOnException(e, this.$lang))
    },
    onLoadAll () {
      MetasRepository.GetAllPaging(
        this.$refs.tableGrid.pagingLimit,
        this.$refs.tableGrid.pagingIndex
      )
        .then(response => {
          this.onResultGrid(response)
        })
        .catch(err => {
          this.onException(err)
        })
    },
    onEdit (obj) {
      this.$emit('Edit', obj)
    },
    formatBooleanToInt (value) {
      if (value === true) return 1
      else return 0
    },
    formatDateAndTime (rawDate) {
      const date = new Date(rawDate)
      const day = date
        .getDate()
        .toString()
        .padStart(2, '0')
      const month = (date.getMonth() + 1).toString().padStart(2, '0')
      const year = date.getFullYear() % 100
      const hours = date
        .getHours()
        .toString()
        .padStart(2, '0')
      const minutes = date
        .getMinutes()
        .toString()
        .padStart(2, '0')

      return `${day}/${month}/${year} às ${hours}:${minutes}`
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/configurations/parametros/metas-gerente/list/MetasList.vue